const heroStats = [
  { value: "8", unit: "步", label: "标准排查流程" },
  { value: "6", unit: "类", label: "常见失效现象" },
  { value: "2", unit: "种", label: "网络对比方法" },
  { value: "8", unit: "条", label: "高频问答" },
];

const quickJumps = [
  { href: "#symptoms", icon: "ri-bug-line", label: "页面打不开" },
  { href: "#address", icon: "ri-link-unlink", label: "地址已失效" },
  { href: "#network", icon: "ri-global-line", label: "网络被拦截" },
  { href: "#faq", icon: "ri-question-line", label: "直接看问答" },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] md:min-h-[640px] flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20dark%20atmospheric%20background%20with%20deep%20teal%20and%20warm%20amber%20light%20streaks%2C%20film%20grain%20texture%2C%20moody%20smoke%2C%20minimal%20artistic%20composition%2C%20no%20text%2C%20high%20contrast%20dark%20tones%20suitable%20for%20white%20text%20overlay&width=1920&height=1080&seq=hero-cinema-01&orientation=landscape"
          alt="抽象的深色光影背景，用于衬托页面标题"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-8 py-24 md:py-28">
        <div className="max-w-4xl animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/12 border border-white/20 text-white/90 text-xs md:text-sm backdrop-blur">
            <i className="ri-information-line"></i>
            访问异常排查与信息整理
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-[3.4rem] font-bold leading-tight text-white">
            秋霞影院在线观看打不开？
            <br className="hidden md:block" />
            一步步找出无法访问的真正原因
          </h1>

          <p className="mt-5 max-w-2xl text-sm md:text-base leading-relaxed text-white/85">
            这里整理的是「访问异常怎么办」：当遇到秋霞影院打不开、无法访问、网页进不去、
            网站被屏蔽、看不了或地址失效时，可以从哪些角度逐一排查。本站不提供播放服务，
            只把常见的现象、原因与自查方法讲清楚，帮你判断问题出在哪一环。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row gap-3">
            <a
              href="#steps"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-route-line"></i>
              查看 8 步排查流程
            </a>
            <a
              href="#symptoms"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap px-6 py-3 rounded-md bg-white/12 border border-white/25 text-white text-sm font-medium hover:bg-white/20 transition-colors cursor-pointer"
            >
              <i className="ri-list-check-2"></i>
              先对照常见现象
            </a>
          </div>

          <div className="mt-9 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-3xl">
            {heroStats.map((s) => (
              <div key={s.label} className="rounded-lg bg-white/10 border border-white/15 backdrop-blur px-4 py-3">
                <div className="flex items-baseline gap-1 text-white">
                  <span className="font-heading text-2xl md:text-3xl font-bold">{s.value}</span>
                  <span className="text-xs text-white/80">{s.unit}</span>
                </div>
                <p className="mt-1 text-xs text-white/75">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 hidden md:block">
        <div className="w-full px-4 md:px-8 pb-5">
          <div className="flex flex-wrap gap-2">
            {quickJumps.map((j) => (
              <a
                key={j.href}
                href={j.href}
                className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-white/10 border border-white/20 text-white/90 text-xs backdrop-blur hover:bg-white/20 transition-colors cursor-pointer"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={j.icon}></i>
                </span>
                {j.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}